import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, exhaustMap, map } from 'rxjs/operators';
import {  of } from 'rxjs';

import * as EventPageActions from './event-page.actions';
import { EventPageService } from '../services/event-page.service';

@Injectable()
export class EventPageEffects {

  getCustomThemes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventPageActions.getCustomThemes),
      exhaustMap((action: any) => {
        return this.eventPageService.getCustomThemesList().pipe(
          map(data => EventPageActions.getCustomThemesSuccess({ data })),
          catchError(error => of(EventPageActions.getCustomThemesFailure({ error }))))
      })
    );
  });

  getCustomTheme$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventPageActions.getCustomTheme),
      exhaustMap(({ payload }) => {
        return this.eventPageService.getCustomTheme(payload.id).pipe(
          map(data => EventPageActions.getCustomThemeSuccess({ data })),
          catchError(error => of(EventPageActions.getCustomThemeFailure({ error }))))
      })
    );
  });

  createCustomTheme$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventPageActions.createCustomTheme),
      exhaustMap(({ payload }) => {
        return this.eventPageService.createCustomTheme(payload).pipe(
          map(data => {
            return EventPageActions.createCustomThemeSuccess({ data });
          }),
          catchError(error => {
            return of(EventPageActions.createCustomThemeFailure({ error }));
          }));
      })
    );
  });

  updateCustomTheme$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventPageActions.updateCustomTheme),
      exhaustMap(({ payload }) => {
        return this.eventPageService.updateCustomTheme(payload).pipe(
          map(data => {
            return EventPageActions.updateCustomThemeSuccess({ data });
          }),
          catchError(error => {
            return of(EventPageActions.updateCustomThemeFailure({ error }));
          }));
      })
    );
  });

  deleteCustomTheme$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventPageActions.deleteCustomTheme),
      exhaustMap(({ payload }) => {
        return this.eventPageService.deleteCustomTheme(payload.id).pipe(
          map(data => {
              return EventPageActions.deleteCustomThemeSuccess({ data });
          }),
          catchError(error => {
            return of(EventPageActions.deleteCustomThemeFailure({ error }));
          }));
      })
    );
  });

  constructor(
    private actions$: Actions,
    private eventPageService: EventPageService
  ) {}

}
